import * as React from 'react'
import { FC } from 'react'
import { Link } from 'gatsby'
import Button from '../../../Button/Button'
import { ROUTE_PATH, ColorsType, TextColorsType } from '../../../../utils/constants'
import { cls } from '../../../../utils/utils'
import * as styles from './ReadyToTalk.module.scss'

const ReadyToTalk: FC<{ btnStyle: ColorsType; colorTitle: TextColorsType; readyToTalkText?: string }> = ({
  btnStyle,
  colorTitle,
  readyToTalkText = 'Ready to talk?',
}) => {
  return (
    <div className={styles.block}>
      <div className={styles.container}>
        <h1 className={cls(styles.question, styles[colorTitle])}>{readyToTalkText}</h1>
        <Link to={ROUTE_PATH.connectWithUs.path} className={styles.button}>
          <Button tabIndex={-1} btnStyle={btnStyle}>
            {ROUTE_PATH.connectWithUs.name}
          </Button>
        </Link>
      </div>
    </div>
  )
}
export default ReadyToTalk
